import { type ISwapSequencs } from '@App/types/common'
import {
    type ITransferServiceDto,
    type ICategoryDto,
    type ISectionRulesWrapper,
    type IServiceRulesWrapper
} from '@App/types/servicesTypes'
import { API_URL } from '@Config/config'

import instance from '../instance'

export class ServicesController {
    onGetAllCategories() {
        return instance.get(`${API_URL}/services/admin/all-services`)
    }

    onAddCategory(dto: ICategoryDto) {
        return instance.post(`${API_URL}/services/admin/category`, dto)
    }

    onEditCategory(dto: ICategoryDto) {
        return instance.put(`${API_URL}/services/admin/category`, dto)
    }

    onRemoveCategory(queries: string) {
        return instance.delete(`${API_URL}/services/admin/category${queries}`)
    }

    onTransferService(dto: ITransferServiceDto) {
        return instance.put(`${API_URL}/services/admin/transfer`, dto)
    }

    onGetServiceRules(code: string) {
        return instance.get(`${API_URL}/preparings/service/${code}`)
    }

    onChangePreparingServiceRulesData(dto: IServiceRulesWrapper) {
        return instance.put(`${API_URL}/preparings/service`, dto)
    }

    onGetSectionsRules(id: string) {
        return instance.get(`${API_URL}/preparings/category/${id}`)
    }

    onChangePreparingRulesData(dto: ISectionRulesWrapper) {
        return instance.put(`${API_URL}/preparings/category`, dto)
    }

    onSwapCategories(dto: ISwapSequencs) {
        return instance.put(`${API_URL}/services/swap-categories`, dto)
    }

    onSwapServices(dto: ISwapSequencs) {
        return instance.put(`${API_URL}/services/swap-services`, dto)
    }
}
